import { t } from "@/i18n";

// Selector compacto de formato (relación de aspecto) — desplegable nativo accesible
// con teclado. Etiqueta cada ratio como "ratio — descripción" tomada del catálogo i18n.
// Si solo hay una opción disponible, el selector se muestra deshabilitado.
const getRatioLabel = (f) => {
  if (t.ratioLabels && t.ratioLabels[f]) return t.ratioLabels[f];
  if (f === "auto") return t.tools.formatAuto;
  return f;
};

const FormatPicker = ({ formats, extendedFormats = [], value, onChange, testPrefix }) => {
  const allFormats = [...formats, ...extendedFormats];
  if (allFormats.length === 0) return null;
  const isDisabled = allFormats.length === 1;
  return (
    <select
      data-testid={`${testPrefix}-select`}
      className="v-input"
      value={value}
      disabled={isDisabled}
      onChange={(e) => onChange(e.target.value)}
      aria-label={t.tools.format}
    >
      {allFormats.map((f) => (
        <option key={f} value={f}>{getRatioLabel(f)}</option>
      ))}
    </select>
  );
};

export default FormatPicker;
